import { z } from 'zod';
import {
    PaymentGatewayTerminalSaleStatus,
    type PaymentGatewayTerminalSaleResult,
} from '../../types/ipg/gateway-terminal-sale.types';

export const PaymentGatewayTerminalSaleApprovedResultSchema: z.ZodObject<{
    status: z.ZodLiteral<typeof PaymentGatewayTerminalSaleStatus.APPROVED>;
    gatewayTransactionId: z.ZodString;
    approvedAmount: z.ZodString;
    authorizationCode: z.ZodOptional<z.ZodString>;
    batchId: z.ZodOptional<z.ZodString>;
    maskedAccount: z.ZodOptional<z.ZodString>;
    gatewayToken: z.ZodOptional<z.ZodString>;
}> = z.object({
    status: z.literal(PaymentGatewayTerminalSaleStatus.APPROVED),
    gatewayTransactionId: z.string().min(1),
    approvedAmount: z.string().min(1),
    authorizationCode: z.string().min(1).optional(),
    batchId: z.string().min(1).optional(),
    maskedAccount: z.string().min(1).optional(),
    gatewayToken: z.string().min(1).optional(),
});

export const PaymentGatewayTerminalSaleDeclinedResultSchema: z.ZodObject<{
    status: z.ZodLiteral<typeof PaymentGatewayTerminalSaleStatus.DECLINED>;
    message: z.ZodString;
    gatewayTransactionId: z.ZodOptional<z.ZodString>;
    responseCode: z.ZodOptional<z.ZodString>;
}> = z.object({
    status: z.literal(PaymentGatewayTerminalSaleStatus.DECLINED),
    message: z.string().min(1),
    gatewayTransactionId: z.string().min(1).optional(),
    responseCode: z.string().min(1).optional(),
});

export const PaymentGatewayTerminalSaleCanceledResultSchema: z.ZodObject<{
    status: z.ZodLiteral<typeof PaymentGatewayTerminalSaleStatus.CANCELED>;
    message: z.ZodString;
    gatewayTransactionId: z.ZodOptional<z.ZodString>;
}> = z.object({
    status: z.literal(PaymentGatewayTerminalSaleStatus.CANCELED),
    message: z.string().min(1),
    gatewayTransactionId: z.string().min(1).optional(),
});

export const PaymentGatewayTerminalSaleMalformedResultSchema: z.ZodObject<{
    status: z.ZodLiteral<typeof PaymentGatewayTerminalSaleStatus.MALFORMED_RESPONSE>;
    message: z.ZodString;
}> = z.object({
    status: z.literal(PaymentGatewayTerminalSaleStatus.MALFORMED_RESPONSE),
    message: z.string().min(1),
});

export const PaymentGatewayTerminalSaleResultSchema: z.ZodType<PaymentGatewayTerminalSaleResult> =
    z.discriminatedUnion('status', [
        PaymentGatewayTerminalSaleApprovedResultSchema,
        PaymentGatewayTerminalSaleDeclinedResultSchema,
        PaymentGatewayTerminalSaleCanceledResultSchema,
        PaymentGatewayTerminalSaleMalformedResultSchema,
    ]);
